import { Col, Divider, Row } from 'antd';
import React from 'react';
import { OrangeButton, PurpleButton, RoundedContainer } from '../../../styles/StyledComponents';
import { StyledTitle } from '../../fields/Title';
import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const MonthlyPricing = () => {
  return (
    <Row
      // gutter={[24, 24]}
      justify='center'
      //   align="middle"
      style={{ gap: 24, marginTop: 120 }}
    >
      <RoundedContainer
        className='hvr-float-shadow'
        xl={5}
        md={12}
        sm={16}
        xs={24}
        style={{ borderTop: '12px solid #8053d7' }}
      >
        <Row justify='start' style={{ textAlign: 'left' }}>
          {/* PACKAGE TITLE */}
          <Col span={24}>
            <h6><FormattedMessage id='pricing-header.basic.label' /></h6>
          </Col>
          <Col span={24}>
            <p style={{ color: '#626266' }}><FormattedMessage id='pricing-header.basic.subTitle' /></p>
          </Col>
        </Row>
        {/* MONTHLY PRICING */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <StyledTitle level={3}><FormattedMessage id='pricing-header.basic.monthly.price' /></StyledTitle>
          </Col>
          <Col>
            <small><FormattedMessage id='pricing-header.basic.description' /></small>
          </Col>
        </Row>
        <br />
        {/* BUILD YOUR PLAN */}
        <Row>
          <Col>
            <Link to='/sign-up'>
              <PurpleButton>
                <FormattedMessage id='pricing-header.get-started-link' /><RightOutlined />
              </PurpleButton>
            </Link>
          </Col>
        </Row>
        <Divider style={{ color: '#626266' }} />
        {/* LIST OF FEATURES */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <ul>
              <li><span style={{ fontWeight: 'bold', fontSize: 16 }}><FormattedMessage id='pricing-header.basic.access-list.access-to' /></span></li>
              <li><FormattedMessage id='pricing-header.basic.access-list.1' /></li>
              <li><FormattedMessage id='pricing-header.basic.access-list.2' /></li>
              <li><FormattedMessage id='pricing-header.basic.access-list.3' /></li>
              <li><FormattedMessage id='pricing-header.basic.access-list.4' /></li>
            </ul>
          </Col>
        </Row>
      </RoundedContainer>
      <RoundedContainer
        className='hvr-float-shadow'
        xl={5}
        md={12}
        sm={16}
        xs={24}
        style={{ borderTop: '12px solid #d7753e' }}
      >
        <Row justify='start' style={{ textAlign: 'left' }}>
          {/* PACKAGE TITLE */}
          <Col span={24}>
            <h6><FormattedMessage id='pricing-header.team.label' /></h6>
          </Col>
          <Col span={24}>
            <p style={{ color: '#626266' }}><FormattedMessage id='pricing-header.team.subTitle' /></p>
          </Col>
        </Row>
        {/* MONTHLY PRICING */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <StyledTitle level={3}>Contact Us</StyledTitle>
          </Col>
          <Col>
            <small><FormattedMessage id='pricing-header.team.description' /></small>
          </Col>
        </Row>
        <br />
        {/* BUILD YOUR PLAN */}
        <Row>
          <Col>
            <Link to='/contact'>
              <OrangeButton>
                <FormattedMessage id='shared-button.contact-us-link' /><RightOutlined />
              </OrangeButton>
            </Link>
          </Col>
        </Row>
        <Divider style={{ color: '#626266' }} />
        {/* LIST OF FEATURES */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <ul>
              <li><span style={{ fontWeight: 'bold', fontSize: 16 }}><FormattedMessage id='pricing-header.team.access-list.access-to' /></span></li>
              <li><span style={{ fontSize: 16 }}><FormattedMessage id='pricing-header.team.access-list.all-features' /><span style={{ fontWeight: 'bold' }}><FormattedMessage id='pricing-header.team.access-list.basic' />,</span> plus</span></li>
              <li><FormattedMessage id='pricing-header.team.access-list.1' /></li>
              <li><FormattedMessage id='pricing-header.team.access-list.2' /></li>
              <li><FormattedMessage id='pricing-header.team.access-list.3' /></li>
              <li><FormattedMessage id='pricing-header.team.access-list.4' /></li>
            </ul>
          </Col>
        </Row>
      </RoundedContainer>
      <RoundedContainer
        className='hvr-float-shadow'
        xl={5}
        md={12}
        sm={16}
        xs={24}
        style={{ borderTop: '12px solid darkorange' }}
      >
        <Row justify='start' style={{ textAlign: 'left' }}>
          {/* PACKAGE TITLE */}
          <Col span={24}>
            <h6><FormattedMessage id='pricing-header.team-plus.label' /></h6>
          </Col>
          <Col span={24}>
            <p style={{ color: '#626266' }}><FormattedMessage id='pricing-header.team-plus.subTitle' /></p>
          </Col>
        </Row>
        {/* MONTHLY PRICING */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <StyledTitle level={3}><FormattedMessage id='shared-button.contact-us-link' /></StyledTitle>
          </Col>
          <Col>
            <small><FormattedMessage id='pricing-header.team-plus.description' /></small>
          </Col>
        </Row>
        <br />
        <br />
        {/* BUILD YOUR PLAN */}
        <Row>
          <Col>
            <Link to='/contact'>
              <OrangeButton style={{ background: 'darkorange' }}>
                <FormattedMessage id='shared-button.contact-us-link' />S <RightOutlined />
              </OrangeButton>
            </Link>
          </Col>
        </Row>
        <Divider style={{ color: '#626266' }} />
        {/* LIST OF FEATURES */}
        <Row justify='start' style={{ textAlign: 'left' }}>
          <Col span={24}>
            <ul>
              <li><span style={{ fontWeight: 'bold', fontSize: 16 }}><FormattedMessage id='pricing-header.team.access-list.access-to' /></span></li>
              <li><span style={{ fontSize: 16 }}>All features in <span style={{ fontWeight: 'bold' }}>Team,</span> plus</span></li>
              <li><FormattedMessage id='pricing-header.team-plus.access-list.1' /></li>
              <li><FormattedMessage id='pricing-header.team-plus.access-list.2' /></li>
              <li><FormattedMessage id='pricing-header.team-plus.access-list.3' /></li>
              <li><FormattedMessage id='pricing-header.team-plus.access-list.4' /></li>
              <li><FormattedMessage id='pricing-header.team-plus.access-list.5' /></li>
            </ul>
          </Col>
        </Row>
      </RoundedContainer>
      {/* <RoundedContainer
            className="hvr-float-shadow"
            xl={5}
            md={12}
            sm={16}
            xs={24}
            style={{borderTop: '12px solid dodgerblue'}}
          >
              <Row justify="start" style={{textAlign: 'left'}}>
              <Col span={24}>
                  <h6>ENTERPRISE</h6>
              </Col>
              <Col span={24}>
                  <p style={{color: '#626266'}}>Empower teams in large organizations</p>
                  </Col>
              </Row>
              <Row justify="start" style={{textAlign: 'left'}}>
                  <Col span={24}>
                  <StyledTitle level={3}>Let's chat</StyledTitle>
                  </Col>
                  <Col>
                  <small>Custom plans and pricing to suit your needs</small>
                  </Col>
              </Row>
              <br/>
              <Row>
                  <Col>
                  <BlueButton>CONTACT SALES</BlueButton>
                  </Col>
              </Row>
              <Divider style={{color: "#626266"}}/>
              <Row justify="start" style={{textAlign: 'left'}}>
                  <Col span={24}>
                  <ul>
                      <li> <span style={{fontSize: 16}}>Everything in <span style={{fontWeight: 'bold'}}>Growth</span>, plus</span></li>
                      <li>Advanced access controls</li>
                      <li>Experiments & Signal reports</li>
                      <li>SSO & automated provisioning</li>
                      <li>Seasonal & events-based pricing</li>
                      <li>Dedicated customer success</li>
                  </ul>
                  </Col>
              </Row>
          </RoundedContainer> */}

    </Row>
  );
};

export default MonthlyPricing;
